import { useBack } from "../http";
import { EpiComplianceSummaryDTO, EpiInspectionListDTO } from "../types/EpiComplianceDTO";
import { EpiDossierDTO } from "../types/EpiDossierDTO";

export class EpiComplianceService {
	constructor() {}
	axiosInstance = useBack();

	async getCompliance(companyId: number, from: string, to: string) {
		try {
			const response = await this.axiosInstance
				.get<EpiComplianceSummaryDTO>(
					`/epi-inspections/compliance/${companyId}?from=${from}&to=${to}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter a gestão da conformidade`, error);
			return undefined;
		}
	}

	async listInspections(companyId: number, from: string, to: string) {
		try {
			const response = await this.axiosInstance
				.get<EpiInspectionListDTO>(
					`/epi-inspections/compliance/${companyId}/inspections?from=${from}&to=${to}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as inspeções`, error);
			return undefined;
		}
	}

	async getDossier(inspectionId: number) {
		try {
			const response = await this.axiosInstance
				.get<EpiDossierDTO>(`/epi-inspections/dossier/${inspectionId}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter o dossiê da inspeção`, error);
			return undefined;
		}
	}

	async getFile(inspectionId: number, fileName: string) {
		try {
			const response = await this.axiosInstance
				.get(`/epi-inspections/dossier/${inspectionId}/file/${fileName}`,
					{ responseType: 'blob' });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter o arquivo da inspeção`, error);
			return undefined;
		}
	}
}
